/**
 * The page of a record, by its backend model name: [path, router state?].
 * Used by notifications and the suspect history. Records shown inside
 * another page (court applications, remands, executions, appeal
 * applications, investigations...) are sent by the backend as their parent.
 */
const ROUTES: Record<string, (id: string) => [string, any?]> = {
  ReceivingInvestigationFile: (id) => [`/investigation-files/${id}`, { id }],
  CaseCreation: (id) => [`/charges/${id}`],
  WitnessProtectionRequest: (id) => [`/witness-protection/${id}`],
  DefendantAppealRequest: (id) => [`/defendant-appeal/${id}`],
  AppealRequest: (id) => [`/prosecutor-appeal/${id}`],
  HigherAdminFeedbackRequest: (id) => [`/higher-admin/${id}`],
  SuspectToWitnessConversion: (id) => [`/suspect-to-witness/${id}`],
  BailRight: (id) => [`/bail-right/${id}`],
  CrimeReference: (id) => [`/incident/${id}`],
  AssetAppealRequest: (id) => [`/asset-appeal/${id}`],
  AssetAppealRespondant: (id) => [`/asset-appeal-respondent/${id}`],
};

export const recordRoute = (model?: string, id?: string | number | null) =>
  model && id ? ROUTES[model]?.(String(id)) : undefined;
